import { __decorate, __metadata } from "tslib";
import { appendStyle, dispatchEvent, getMobileMatchMediaAndSubscribe, subscribe, translate, } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/segmented-control';
import { Maskito } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { fromEvent, tap } from 'rxjs';
import { fusionSwapInfoSlippageStyle } from './fusion-swap-info-slippage.style';
let FusionSwapInfoSlippageElement = class FusionSwapInfoSlippageElement extends LitElement {
    constructor() {
        super(...arguments);
        this.mobileMedia = getMobileMatchMediaAndSubscribe(this);
        this.segmentsCustom = {
            label: 'Custom',
            value: 'custom',
            template: () => html `${this.customSlippageInput}`,
        };
        this.segments = [
            { label: 'Auto', value: 'auto' },
            { label: '0.1%', value: 0.1 },
            { label: '0.5%', value: 0.5 },
            { label: '1%', value: 1 },
            this.segmentsCustom,
        ];
        this.postfix = '%';
        this.customSlippageInput = document.createElement('input');
    }
    static { this.tagName = 'inch-fusion-swap-info-slippage'; }
    static { this.styles = fusionSwapInfoSlippageStyle; }
    connectedCallback() {
        super.connectedCallback();
        this.buildMask();
        this.settings?.startChangingValue();
        this.customSlippageInput.placeholder = 'Custom %';
        this.customSlippageInput.inputMode = 'decimal';
        this.customSlippageInput.autocomplete = 'off';
        appendStyle(this.customSlippageInput, {
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            padding: '0',
            color: 'var(--color-content-content-primary)',
            width: '80px',
            fontSize: '16px',
            textAlign: 'center',
        });
        subscribe(this, [
            fromEvent(this.customSlippageInput, 'input').pipe(tap(() => {
                if (this.customSlippageInput.value.length === 1) {
                    this.customSlippageInput.value = '';
                }
                const inputValue = parseFloat(this.customSlippageInput.value.replace(this.postfix, ''));
                this.settings?.setValue([inputValue, 'custom']);
            })),
        ], { requestUpdate: false });
    }
    render() {
        appendStyle(this.customSlippageInput, {
            fontSize: this.mobileMedia.matches ? '13px' : '16px',
        });
        return html `
      <div @click="${() => this.onBack()}" class="slippage-title">
        <inch-icon class="back-icon" icon="chevronDown16"></inch-icon>
        <span>${translate('widgets.swap-form.fusion-info.slippage-tolerance')}</span>
      </div>
      <inch-segmented-control
        .items="${this.segments}"
        .select="${this.getStartSection()}"
        @change="${(event) => this.onChange(event)}"
      ></inch-segmented-control>
    `;
    }
    buildMask() {
        return new Maskito(this.customSlippageInput, maskitoNumberOptionsGenerator({
            max: 99,
            min: 1,
            precision: 2,
            postfix: this.postfix,
        }));
    }
    onBack() {
        const value = this.settings?.value ?? null;
        if (value && value[1] === 'custom' && (value[0] === null || isNaN(value[0]))) {
            this.settings?.resetValue();
        }
        this.settings?.endChangingValue();
        dispatchEvent(this, 'back', null);
    }
    onChange({ detail }) {
        const value = detail.value;
        if (value === 'auto') {
            this.settings?.cleanValue();
            return;
        }
        if (value === 'custom') {
            const inputValue = parseFloat(this.customSlippageInput.value.replace(this.postfix, ''));
            this.settings?.setValue([inputValue, 'custom']);
            return;
        }
        this.settings?.setValue([detail.value, 'preset']);
    }
    getStartSection() {
        if (!this.settings || this.settings.value === null)
            return this.segments[0];
        const [value, type] = this.settings.value;
        if (type === 'custom') {
            if (isNaN(parseFloat(value.toString())))
                return this.segments[0];
            this.customSlippageInput.value = `${value}%`;
            return this.segmentsCustom;
        }
        if (type === 'preset') {
            const preset = this.segments.find((item) => item.value === value);
            if (!preset)
                return this.segments[0];
            return preset;
        }
        throw new Error('Invalid slippage type');
    }
};
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], FusionSwapInfoSlippageElement.prototype, "settings", void 0);
FusionSwapInfoSlippageElement = __decorate([
    customElement(FusionSwapInfoSlippageElement.tagName)
], FusionSwapInfoSlippageElement);
export { FusionSwapInfoSlippageElement };
//# sourceMappingURL=fusion-swap-info-slippage.element.js.map